import React from 'react';
import styled from 'styled-components';

const GalleryWrap = styled.div`
  margin-top: 1rem;
`;

const GalleryTitle = styled.div`
  color: #a0aec0;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  letter-spacing: 0.5px;
`;

const Strip = styled.div`
  display: grid;
  /* Fixed-width columns that wrap; center the whole row */
  grid-template-columns: repeat(auto-fit, minmax(165px, 165px));
  gap: 0.5rem;
  justify-items: center; /* center items within their grid cells */
  justify-content: center; /* center the set of columns within the container */
`;

const Shot = styled.a`
  display: block;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(255,255,255,0.08);
  background: rgba(255,255,255,0.05);
  height: 120px; /* +50% height from original 80px */
  width: 165px; /* +50% width from original 110px */
  justify-self: center; /* ensure the card itself is centered in its cell */
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center; /* center image inside the card */
  display: block;
`;

type TinyGalleryProps = {
  images: string[];
  title?: string;
};

// Uses LoremFlickr's free image endpoint with keyword queries
// No API key required; returns keyword-relevant photography
export const TinyGallery: React.FC<TinyGalleryProps> = ({
  images,
  title = 'Gallery'
}) => {
  const urls = images;

  return (
    <GalleryWrap>
      <GalleryTitle>{title}</GalleryTitle>
      <Strip>
        {urls.map((u, idx) => (
          <Shot key={idx} href={u} target="_blank" rel="noreferrer noopener" aria-label="Open image in new tab">
            <Img src={u} loading="lazy" alt="Sailing adventure inspiration" />
          </Shot>
        ))}
      </Strip>
    </GalleryWrap>
  );
};

export default TinyGallery;
